export const authenticateFederatedCredentialsPopUp = (tenant: any, firebase: any): Promise<any> => {
  const newAuth = firebase.auth();
  newAuth.tenantId = tenant.tenantID;
  const provider = new firebase.auth.OAuthProvider(tenant.loginProviderID);

  return newAuth.signInWithPopup(provider);
};
